module.exports = __webpack_public_path__ + "static/media/user.d00d5149.png";